const NAV_MAIN_SELECTOR = '[data-js="nav-main"]';
const NAV_CLOSE_BUTTON_SELECTOR = '[data-js="nav-btn-close"]';
const NAV_OPEN_BUTTON_SELECTOR = '[data-js="nav-btn"]';
const NAV_SMOOTH_SCROLL_LINK_SELECTOR = '[data-js="smooth-scroll"]';
const NAV_TOGGLE_CLASS = 'is-active';

export default class NavMain {

    constructor() {
        this.navMain = document.querySelector( NAV_MAIN_SELECTOR );
        this.navCloseButton = document.querySelector( NAV_CLOSE_BUTTON_SELECTOR );
        this.navOpenButton = document.querySelector( NAV_OPEN_BUTTON_SELECTOR );
        this.smoothScrollLinks = document.querySelectorAll( NAV_SMOOTH_SCROLL_LINK_SELECTOR );
        this.registerEventListener();
    }

    registerEventListener () {
        this.navCloseButton && this.navCloseButton.addEventListener( 'click', () => this.hide() );
        this.navOpenButton && this.navOpenButton.addEventListener( 'click', () => this.show() );

        for ( const smoothScrollLink of this.smoothScrollLinks ) {
            smoothScrollLink && smoothScrollLink.addEventListener( 'click', () => this.hide() );
        }
    }

    show () {
        this.navMain && this.navMain.classList.add( NAV_TOGGLE_CLASS );
    }

    hide () {
        this.navMain && this.navMain.classList.remove( NAV_TOGGLE_CLASS );
    }
}

